import React from "react";
import codexmon from "../Assets/codexmon.png";
import github from "../Assets/github.png";
import linkedin from "../Assets/linkedin.png";

const Footer = () => {
  return (
    <div className="footer-section">
      <h4>©2022 Gloria Ng. All rights reserved.</h4>
      <div>
        <a href="https://codexmon.github.io/">
          <img src={codexmon} alt="Codexmon" />
        </a>
        <a href="https://github.com/codexmon">
          <img src={github} alt="Github" />
        </a>
        <a href="https://linkedin.com/in/fengshuigal">
          <img src={linkedin} alt="LinkedIn" />
        </a>
      </div>
      <div className="privacy-policy">
      <p>We don't log or share personal info. We don't track or profile you.</p>
      <p>Searches go poof on exit/reload.</p>
      </div>
    </div>
  );
};

export default Footer;
